import { PageResponse } from '@core/entities/pagination'
import {
  useInfiniteQuery,
  UseInfiniteQueryOptions,
} from '@tanstack/react-query'
import { tasksKeys, RequestTypes } from '@core/react-query/features/tasks/tasks'
import { RequestErrorType } from '@core/utils/api-axios-instance'
import { usePageableQuery } from '@core/react-query/hooks'
import {
  ITaskPaginated,
  TaskPaginated,
} from '@core/entities/task/TaskPaginated'

const dataTransformer = ({ content }: PageResponse<ITaskPaginated>) => {
  return content.map((task) => TaskPaginated.new(task))
}

export const useGetAllTasksInfinityQuery = (
  payload: RequestTypes['getAllTasks'],
  options: UseInfiniteQueryOptions<
    PageResponse<ITaskPaginated>,
    RequestErrorType,
    Array<TaskPaginated>
  > = {},
) => {
  const allTasksQuery = tasksKeys.allTasks(payload)
  const infiniteQueryOptions = usePageableQuery({
    queryEnabled: options.enabled,
    queryKey: allTasksQuery.queryKey,
    dataTransformer,
  })

  return useInfiniteQuery<
    PageResponse<ITaskPaginated>,
    RequestErrorType,
    Array<TaskPaginated>
  >({
    ...infiniteQueryOptions,
    ...allTasksQuery,
    ...options,
  })
}
